module.exports = __webpack_public_path__ + "static/media/training-documentation-dark.ed18b267.svg";